import { Column, ColumnKeys, Dependencies, ExchangeProtectionItem, QuarantineExchangeMethod } from '../types';
import { GridBaseDataProvider } from '../../../grid/GridBaseDataProvider';
import {
  GetRowsRequest,
  GetSummaryResponse,
  UpdateSettingsRequest,
  UpdateSettingsResponse,
} from '../../../grid/types/common';
import { ConsoleRequest, DataProviderType, FilterKeyMapper } from 'apps/webcomponents/src/utils/request';
import { API_TYPE_QUARANTINE } from 'apps/webcomponents/src/webcomponents.constants';

export class ExchangeProtectionGridDataProvider extends GridBaseDataProvider<Column, ColumnKeys> {
  private endpoint = 'QuarantineExchange';
  private cache;
  public companyFilterDataProvider = API_TYPE_QUARANTINE;

  /**
   * Maps column key to different filter key as we filter with a different one.
   */
  private filterKeyMapper: FilterKeyMapper = {
    'source.company.name': 'source.company.id',
  };

  constructor(public dependencies: Dependencies) {
    super();
  }

  async getSummary(request: GetRowsRequest<Column, ColumnKeys>): Promise<GetSummaryResponse> {
    const response = await this.readRecords(request);

    return { numItems: response.total, summary: '' };
  }

  async getRows(request: GetRowsRequest<Column, ColumnKeys>): Promise<{ rawEvents: Array<ExchangeProtectionItem> }> {
    const response = await this.readRecords(request);

    return { rawEvents: response.data };
  }

  async setFilters(request: any): Promise<{} | undefined> {
    return {};
  }

  async updateSettings(request: UpdateSettingsRequest<Column>): Promise<UpdateSettingsResponse> {
    return {};
  }

  private async readRecords(request: GetRowsRequest<Column, ColumnKeys>): Promise<any> {
    if (this.cache) {
      const response = Promise.resolve(this.cache);
      this.cache = null;

      return response;
    }

    const payload = ConsoleRequest.mapGridRequestToPayload(
      request,
      this.dependencies.getTimezone(),
      this.filterKeyMapper
    );

    const response = await ConsoleRequest.createRequest<any>({
      dataProviderType: DataProviderType.ENDPOINTS,
      payload,
      endpoint: this.endpoint,
      method: QuarantineExchangeMethod.READ_RECORDS,
    });

    this.cache = response;

    return response;
  }
}
